export default __webpack_public_path__ + "static/media/Indigo.94bb0c22.png";